import Base from '../../ts/_base';

export default class CopyElementContent extends Base {

    private get childSelectors(): {[key: string]: string} {
        return {
            copyBtn: '.btn-copy-content',
            targetDataAttribute: 'copyTarget',
            copyStatus: '.copy__status',
            authorsDataItemMore: '.authors-data-item-more',
            elementsToShowInline: 'elementsToShowInline',
            elementsToRemove: 'elementsToRemove',
        }
    }
    private messageStatusDuration: number = 3000;
    

    constructor() {
        super();
    }
    
    initialize(): void {
        this.subscribeToEvent('click', this.childSelectors.copyBtn, this.controller.bind(this));
    }

    async controller(e: Event): Promise<void> {
        const copyBtn = e.currentTarget as HTMLButtonElement;
        const copyTarget = copyBtn.dataset[this.childSelectors.targetDataAttribute];
        
        if (copyTarget) {
            const elementToCopy = document.querySelector(copyTarget) as HTMLElement | null;
            
            if (elementToCopy) {
                const copyStatus = this.queryElm(this.childSelectors.copyStatus) as HTMLElement;
                
                try {
                    await this.copyTextToClipboard(elementToCopy);
                    this.showCopyStatus(copyStatus, 'success');
                } catch {
                    this.showCopyStatus(copyStatus, 'failed');
                }
            }
        }
    }
    
    private async copyTextToClipboard(elementToCopy: HTMLElement): Promise<void> {
        const temp = elementToCopy.cloneNode(true) as HTMLDivElement;
        const elementsToShowInline = temp.querySelectorAll(elementToCopy.dataset[this.childSelectors.elementsToShowInline]);
        const elementsToRemove = temp.querySelectorAll(elementToCopy.dataset[this.childSelectors.elementsToRemove]);
        let authorsDataItemMore = temp.querySelector(this.childSelectors.authorsDataItemMore) as HTMLElement;
        temp.style.position = 'absolute';
        temp.style.top = '-9999px';
        temp.style.left = '-9999px';
        temp.style.opacity = '0';
        elementsToShowInline.forEach((elm) => (elm as HTMLElement).style.display = 'inline');
        elementsToRemove.forEach((elm) => elm.remove());
        temp.querySelectorAll('.d-none').forEach((elm) => elm.classList.remove('d-none'));
        if (authorsDataItemMore) {
            authorsDataItemMore.innerText = authorsDataItemMore.innerText.split(',').join(', ').trim();
        }
        document.body.appendChild(temp);
        await navigator.clipboard.writeText(temp.innerText);
        document.body.removeChild(temp);
    }
    
    private showCopyStatus(copyStatus: HTMLElement, status: 'success' | 'failed'): void {
        copyStatus.classList.add(status);
        setTimeout(() => {
            copyStatus.classList.remove(status);
        }, this.messageStatusDuration);
    }
}